import React from 'react'
import { Paper, Grid, MenuItem, Button, TextField } from '@mui/material'
import { useStyles } from './styles'
import typePositionBusiness from '../../actions/typePositionBusiness'
import { useTypePosition } from '../../context'

interface TypePositionSearchProps {}

export const TypePositionSearch: React.FC<TypePositionSearchProps> = () => {
  const classes = useStyles()

  const {
    state: { searchFields: search }
  } = useTypePosition()
  const { handleSearch, fetchTypePositions } = typePositionBusiness()

  return (
    <Paper elevation={3}>
      <div className={classes.flexContainer}>
        <div className={classes.filters}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={5}>
              <TextField
                fullWidth
                variant='outlined'
                id='searchField'
                name='searchField'
                value={search.searchField}
                label='Buscar por'
                select
                onChange={handleSearch}
              >
                <MenuItem value={'TypePositionCode'}>Código</MenuItem>

                <MenuItem value={'TypePositionDescription'}>
                  Descripción
                </MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={5}>
              <TextField
                variant='outlined'
                id='searchValue'
                name='searchValue'
                label={`Valor a buscar`}
                onChange={handleSearch}
                type='text'
                value={search.searchValue}
              />
            </Grid>
          </Grid>
        </div>
        <div className={classes.actions}>
          <span>
            <Button
              disabled={search.searchValue !== '' && search.searchField === ''}
              variant='contained'
              color='primary'
              onClick={() => fetchTypePositions()}
            >
              Buscar
            </Button>
          </span>
        </div>
      </div>
    </Paper>
  )
}
